import type { ItemRenderer } from "./types";
import { SectionItemI } from "../../../../shared";

const registry = new Map<string, ItemRenderer>();

export const registerItemRenderer = (key: string, renderer: ItemRenderer) => {
    registry.set(key.toLowerCase(), renderer);
};

export const resolveItemType = (shelf: SectionItemI) => {
    const rawTypes = shelf?.type || [];
    const hay = rawTypes.map((t) => t.toLowerCase());
    if (hay.some((t) => t.includes("перфопан"))) return "перфопанель";
    if (hay.some((t) => t.includes("откид") || t.includes("верстак"))) return "откидной стол";
    if (hay.some((t) => t.includes("рейлинг"))) return "рейлинг";
    if (hay.some((t) => t.includes("кроншт"))) return "кронштейн";
    if (hay.some((t) => t.includes("шкаф"))) return "шкафчик";
    if (hay.some((t) => t.includes("модуль") || t.includes("держател"))) return "модуль";
    if (hay.some((t) => t.includes("полк"))) return "полка";
    return "generic";
};

export const getRenderer = (key: string): ItemRenderer | undefined => registry.get(key.toLowerCase());

export const fallbackRenderer: ItemRenderer = ({ svg, bboxPx }) => {
    svg.rect(bboxPx.w, bboxPx.h).move(bboxPx.x, bboxPx.y).fill("none").stroke({ width: 0.5, color: "#a64022" });
};
